import { useEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number | null) {
    const callbackRef = useRef(callback);
    // Store callback in ref so that the useEffect isn't triggered (resetting the timeout) when it changes
    useEffect(() => {
        callbackRef.current = callback;
    });

    useEffect(() => {
        if (delay == null) {
            return;
        }

        const handle = setInterval(() => {
            callbackRef.current();
        }, delay);

        // Clear previous timeout, if still pending
        return () => {
            clearInterval(handle);
        };
    }, [delay]);
}
